import * as React from 'react'

const style = require('./Card.css')

interface Props {
  children: React.ReactNode;
}

interface HeaderProps {
  children: React.ReactNode;
  large: boolean;
}

const Content = ({ children }: Props) => (
  <div className={style.content}>
    {children}
  </div>
)

const Header = ({ children, large }: HeaderProps) => (
  <h3 className={`${style.header} ${large ? style.large : ''}`}>
    {children}
  </h3>
)

export class Card extends React.Component<Props> {
  static Header = Header
  static Content = Content

  render() {
    return (
      <div className={style.card}>
        {this.props.children}
      </div>
    )
  }
}
